// Importar funciones de Firebase
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Configuración de tu proyecto Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBuCRGkghEcJwErJ2Tqic-la0SqBwFiJes",
  authDomain: "boda-martinyjuly.firebaseapp.com",
  projectId: "boda-martinyjuly",
  storageBucket: "boda-martinyjuly.firebasestorage.app",
  messagingSenderId: "724917631833",
  appId: "1:724917631833:web:3ea1e34203d37550b3aa48",
  measurementId: "G-6XZ1PZQ1XC",
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar Firestore (la base de datos que vamos a usar)
export const db = getFirestore(app);
